export default __webpack_public_path__ + "static/media/carouselPrevGray.618d723c.svg";